const Marionette = require('backbone.marionette');

module.exports = Marionette.Behavior.extend({
    initialize: function(options) {
        this.selectors = [];
        if (_.some(options.selectors)) {
            this.selectors.push(options.selectors);
        }
    },
    onDomRefresh: function() {
        let selectors = this.selectors;
        if (this.view.forceSelect2PlaceholderSelectors) {
            selectors = selectors.concat(this.view.forceSelect2PlaceholderSelectors());
        }
        if (_.some(selectors)) {
            _.defer(function() {
                let selector = selectors.join(',');
                // This 'change.select2' event causes the ui to update without triggering the full 'change' event. This
                // is to avoid triggering a model change event, which can subsequently cause the grid to think the
                // filters have changed and make unneeded fetch.
                this.view.$(selector).trigger('change.select2');
            }.bind(this));
        }
    }
});
